// The final feedback questionnaire (30.10.2026): the page's words and its
// small rules. Validated in docs/texte-feedback-final-2026-10-30.md.

export const TEXT = {
  saved: "Răspunsurile tale se păstrează în acest browser până le trimiți, așa că poți reveni dacă închizi pagina.",
  answerThis: "Răspunde la această întrebare.",
  network: "Nu am putut trimite răspunsurile. Verifică conexiunea și apasă din nou Trimite. Răspunsurile tale sunt încă aici.",
  optional: "(opțional)",
};

/** The required questions without an answer, in order. 0 is an answer. */
export function missing(definition, answers) {
  return (definition?.questions || [])
    .filter((q) => q.required)
    .filter((q) => {
      const v = answers?.[q.id];
      return v === undefined || v === null || (typeof v === "string" && !v.trim());
    })
    .map((q) => q.id);
}

/** "Ana P. · Limba română, Cluj-Napoca": how a testimonial would be signed. */
export function signatureLine(sig) {
  if (!sig) return "";
  const where = [sig.role, sig.city].filter(Boolean).join(", ");
  return [sig.name, where].filter(Boolean).join(" · ");
}

// After signing in from the trainer's group link, the portal brings the
// person back to it. Only a feedback address, and only for an hour.
const RETURN_KEY = "fped_portal_return";
const RETURN_FOR_MS = 60 * 60 * 1000;

export function rememberReturn(path, storage = typeof window !== "undefined" ? window.localStorage : null, now = Date.now()) {
  if (!storage || !/^\/feedback\/[a-z0-9]{1,20}$/.test(path || "")) return;
  try { storage.setItem(RETURN_KEY, JSON.stringify({ path, at: now })); } catch { /* blocked: they go to the portal */ }
}

export function takeReturn(storage = typeof window !== "undefined" ? window.localStorage : null, now = Date.now()) {
  if (!storage) return null;
  try {
    const raw = storage.getItem(RETURN_KEY);
    storage.removeItem(RETURN_KEY);
    const saved = raw ? JSON.parse(raw) : null;
    if (!saved || now - saved.at > RETURN_FOR_MS || !/^\/feedback\/[a-z0-9]{1,20}$/.test(saved.path || "")) return null;
    return saved.path;
  } catch {
    return null;
  }
}
